import { createSelector } from 'reselect';
import path from 'ramda/es/path';


const selectDnevnikType = createSelector(
  [
    (state, { studentId }) => path(['students', 'data', studentId], state),
    (state, { studentId }) => path(['eljur', 'user', 'result', 'relations', 'students', studentId], state),
  ],
  (internalStudent, externalStudent) => {
    if (internalStudent) {
      if (internalStudent.dnevnikExternalService) {
        return 'eljur';
      }
      return 'internal';
    }
    if (externalStudent) {
      return 'eljur';
    }
    return null;
  }
);

export default selectDnevnikType;
